export default __webpack_public_path__ + "static/media/BLR3.2cd3eca1.jpg";